import { useLocation } from "react-router-dom";

export const PrivacyPolicy = () => {
   const location = useLocation();
   const navigate = location.state?.name ? `games/${location.state.name}` : 'about'
   return (
      <div
         className="font-concert text-[14px] md:text-[20px] lg:text-[24px] xl:text-[36px] text-[#5C5C5C] select-none flex w-full h-screen md:w-auto overflow-x-scroll no-scrollbar flex-col items-center bg-cover bg-[url('/backGrounds/home.svg')] z-0 relative"
      >
         <div className="absolute top-4 right-4 z-10">
            <button
               onClick={() => window.location.href = `/${navigate}`}
               className="text-[#2F9EBA] bg-white/70 hover:bg-[#2F9EBA] hover:text-white border border-[#2F9EBA] px-4 py-2 rounded-xl shadow-md transition duration-300"
            >
               Back
            </button>
         </div>
         <div className="w-[90%] text-left mt-[50px] text-[#8048C2]">Privacy Policy</div>
         <div className="w-[90%] mt-[20px]">
            WitPlex LLC built the MathGame app as a Commercial app. This SERVICE is provided by WitPlex LLC and is intended for use as is.
         </div>
         <div className="w-[90%]">
            This page is used to inform visitors regarding our policies with the collection, use, and disclosure of Personal Information if anyone decided to use our Service.
         </div>
         <div className="w-[90%]">
            If you choose to use our Service, then you agree to the collection and use of information in relation to this policy. The Personal Information that we collect is used for providing and improving the Service. We will not use or share your information with anyone except as described in this Privacy Policy
         </div>
         <div className="w-[90%]">
            The terms used in this Privacy Policy have the same meanings as in our Terms and Conditions, which is accessible at MathGame unless otherwise defined in this Privacy Policy.
         </div>
         <div className="w-[90%] text-left text-[#2F9EBA] mt-[10px]">
            Information Collection and Use
         </div>
         <div className="w-[90%]">
            For a better experience, while using our Service, we may require you to provide us with certain personally identifiable information, including but not limited to email. The information that we request will be retained by us and used as described in this privacy policy.
         </div>
         <div className="w-[90%]">
            The app does use third party services that may collect information used to identify you.
         </div>
         <div className="w-[90%]">
            Link to privacy policy of third party service providers used by the app
         </div>
         <ul className="w-[90%] list-disc ml-[10%]">
            <a className="underline text-[#85B054]" target="_blank" href="https://policies.google.com/privacy">
               <li>Google Play Services</li>
            </a>
            <a className="underline text-[#85B054]" target="_blank" href="https://firebase.google.com/policies/analytics">
               <li>Firebase Analytics</li>
            </a>
            <a className="underline text-[#85B054]" target="_blank" href="https://www.facebook.com/privacy/policy/?entry_point=data_policy_redirect&entry=0">
               <li>Facebook</li>
            </a>
            <a className="underline text-[#85B054]" target="_blank" href="https://firebase.google.com">
               <li>Fabric</li>
            </a>
            <a className="underline text-[#85B054]" target="_blank" href="http://static.googleusercontent.com/media/try.crashlytics.com/en//terms/privacy-policy.pdf">
               <li>Crashlytics</li>
            </a>
         </ul>
         <div className="w-[90%] text-left text-[#2F9EBA] mt-[20px]">
            Log Data
         </div>
         <div className="w-[90%]">
            We want to inform you that whenever you use our Service, in a case of an error in the app we collect data and information (through third party products) on your phone called Log Data. This Log Data may include information such as your device Internet Protocol (“IP”) address, device name, operating system version, the configuration of the app when utilizing our Service, the time and date of your use of the Service, and other statistics.
         </div>
         <div className="w-[90%] text-left text-[#2F9EBA] mt-[20px]">
            Cookies
         </div>
         <div className="w-[90%]">
            Cookies are files with a small amount of data that are commonly used as anonymous unique identifiers. These are sent to your browser from the websites that you visit and are stored on your device's internal memory.
         </div>
         <div className="w-[90%] mt-[10px]">
            This Service does not use these “cookies” explicitly. However, the app may use third party code and libraries that use “cookies” to collect information and improve their services. You have the option to either accept or refuse these cookies and know when a cookie is being sent to your device. If you choose to refuse our cookies, you may not be able to use some portions of this Service.
         </div>
         <div className="w-[90%] text-left text-[#2F9EBA] mt-[20px]">
            Service Providers
         </div>
         <div className="w-[90%]">
            We may employ third-party companies and individuals due to the following reasons:
         </div>
         <ul className="w-[90%] list-disc ml-[10%] mt-[10px]">
            <li>To facilitate our Service;</li>
            <li>To provide the Service on our behalf;</li>
            <li>To perform Service-related services; or</li>
            <li>To assist us in analyzing how our Service is used.</li>
         </ul>
         <div className="w-[90%] mt-[10px]">
            We want to inform users of this Service that these third parties have access to your Personal Information. The reason is to perform the tasks assigned to them on our behalf. However, they are obligated not to disclose or use the information for any other purpose.
         </div>
         <div className="w-[90%] text-left text-[#2F9EBA] mt-[20px]">
            Security
         </div>
         <div className="w-[90%]">
            We value your trust in providing us your Personal Information, thus we are striving to use commercially acceptable means of protecting it. But remember that no method of transmission over the internet, or method of electronic storage is 100% secure and reliable, and we cannot guarantee its absolute security.
         </div>
         <div className="w-[90%] text-left text-[#2F9EBA] mt-[20px]">
            Links to Other Sites
         </div>
         <div className="w-[90%]">
            This Service may contain links to other sites. If you click on a third-party link, you will be directed to that site. Note that these external sites are not operated by us. Therefore, we strongly advise you to review the Privacy Policy of these websites. We have no control over and assume no responsibility for the content, privacy policies, or practices of any third-party sites or services.
         </div>
         <div className="w-[90%] text-left text-[#2F9EBA] mt-[20px]">
            Children’s Privacy
         </div>
         <div className="w-[90%]">
            These Services do not address anyone under the age of 13. We do not knowingly collect personally identifiable information from children under 13. In the case we discover that a child under 13 has provided us with personal information, we immediately delete this from our servers. If you are a parent or guardian and you are aware that your child has provided us with personal information, please contact us so that we will be able to do necessary actions.
         </div>
         <div className="w-[90%] text-left text-[#2F9EBA] mt-[20px]">
            Changes to This Privacy Policy
         </div>
         <div className="w-[90%]">
            We may update our Privacy Policy from time to time. Thus, you are advised to review this page periodically for any changes. We will notify you of any changes by posting the new Privacy Policy on this page. These changes are effective immediately after they are posted on this page.
         </div>
         <div className="w-[90%] text-left text-[#2F9EBA] mt-[20px]">
            Contact Us
         </div>
         <div className="w-[90%]">
            If you have any questions or suggestions about our Privacy Policy, do not hesitate to contact us.
         </div>
         <a className="text-[#85B054] w-[90%] text-left underline my-[10px]" href="mailto:mathgame@witplex.com">mathgame@witplex.com</a>
      </div>
   )
}